import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-white py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-198">
      <div className="max-w-3xl mx-auto" data-id="element-199">
        {/* The Pain */}
        <div className="mb-12 sm:mb-16" data-id="element-200">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-[#4C1D95] mb-6 sm:mb-8 text-center" data-id="element-201">
            Si estás lesionado, no solo duele el tejido.
          </h2>

          <p className="text-base sm:text-lg text-[#444444] mb-4 sm:mb-6 leading-relaxed" data-id="element-202">
            Duele lo que te quita:
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-8 sm:mb-10" data-id="element-203">
            {['Tu rutina', 'Tu energía', 'Tu humor', 'Tu identidad de "persona activa"'].map((item, i) => <li key={i} className="flex items-center p-3 sm:p-4 bg-[#F5F0E6] rounded-lg border border-[#E8E3D9]" data-id="element-204">
                <XCircle className="w-5 h-5 text-[#DC2626] mr-3 flex-shrink-0" data-id="element-205" />
                <span className="text-sm sm:text-base text-[#333333] font-medium" data-id="element-206">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="text-base sm:text-lg text-[#444444] leading-relaxed" data-id="element-207">
            Y lo peor: la lesión te empuja a decisiones impulsivas. Porque
            cuando algo se siente incierto, el cerebro busca control. Y si no lo
            encuentra… compra esperanza.
          </p>
        </div>

        {/* The Real Problem */}
        <div className="bg-[#F5F0E6] p-5 sm:p-8 md:p-10 rounded-2xl border border-[#E8E3D9] shadow-sm mb-12 sm:mb-16" data-id="element-208">
          <div className="flex items-start mb-4 sm:mb-6" data-id="element-209">
            <AlertCircle className="w-6 h-6 sm:w-8 sm:h-8 text-[#7C3AED] mr-3 sm:mr-4 flex-shrink-0 mt-0.5" data-id="element-210" />
            <div data-id="element-211">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-[#4C1D95] mb-2" data-id="element-212">
                El problema real no es "tener dolor".
              </h3>
              <p className="text-base sm:text-lg text-[#555555]" data-id="element-213">
                El problema real es no saber qué significa.
              </p>
            </div>
          </div>

          <div className="space-y-3 sm:space-y-4 pl-4 sm:pl-6 md:pl-12 border-l-2 border-[#7C3AED]/30 italic text-sm sm:text-base text-[#555555]" data-id="element-214">
            <p data-id="element-215">"¿Esto es normal o estoy empeorando?"</p>
            <p data-id="element-216">"¿Puedo entrenar o me estoy dañando?"</p>
            <p data-id="element-217">"¿Me conviene mover, estirar, fortalecer, descansar?"</p>
          </div>
        </div>

        {/* The Cycle */}
        <div className="text-center" data-id="element-218">
          <p className="text-base sm:text-lg text-[#444444] mb-6 sm:mb-8" data-id="element-219">
            Cuando no tienes un sistema, haces lo que hacemos todos. Un día te
            cuidas demasiado. Al siguiente te desesperas y te pasas.
          </p>

          <div className="inline-flex flex-col items-center justify-center gap-3 p-5 sm:p-6 bg-[#4C1D95] text-white rounded-xl shadow-lg w-full sm:w-auto sm:flex-row sm:gap-6 md:gap-8" data-id="element-220">
            <span className="font-bold text-lg sm:text-xl" data-id="element-221">Mejoro</span>
            <span className="hidden sm:block" data-id="element-222">→</span>
            <span className="block sm:hidden text-purple-300" data-id="element-223">↓</span>
            <span className="font-bold text-lg sm:text-xl text-[#A3E635]" data-id="element-224">
              Me confío
            </span>
            <span className="hidden sm:block" data-id="element-225">→</span>
            <span className="block sm:hidden text-purple-300" data-id="element-226">↓</span>
            <span className="font-bold text-lg sm:text-xl opacity-80" data-id="element-227">
              Recaigo
            </span>
          </div>

          <p className="mt-6 sm:mt-8 text-lg sm:text-xl font-serif italic text-[#555555]" data-id="element-228">
            Este ebook existe para una sola cosa: <br data-id="element-229" />
            <span className="font-bold text-[#4C1D95] not-italic" data-id="element-230">
              devolverte control sin venderte fantasía.
            </span>
          </p>
        </div>
      </div>
    </section>;
}